export default __webpack_public_path__ + "static/media/comp3.17714de3.png";